import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function RealEstateInvestment() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.real-estate-investment.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/real-estate-investment"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/real-estate/real-esate-investment-hero.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <InfoBlocks
                        title={tp('options.title')}
                        blocks={obj('options.blocks')}
                    />

                    <ServiceCards
                        title={tp('services.title')}
                        services={obj('services.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
